/* components/versioning/VersionCompareModal.jsx — сравнение двух снимков сущности.
   Версия A (на которой нажали «Сравнить») vs выбранная B (другая версия / текущее).
   Тело — DiffView (скаляры + составные). Кнопка «Восстановить версию A».
   ХЕНДОФФ → frontend/src/components/versioning/VersionCompareModal.jsx. */

import React from 'react';
import { Button } from '../ui/Button.jsx';
import { NativeSelect } from '../ui/Field.jsx';
import { Icon } from '../ui/Icon.jsx';
import { Modal } from '../ui/Modal.jsx';
import { DiffView } from './DiffView.jsx';
import { fmt } from '../../lib/format.js';

  const { useState, useMemo } = React;

  function VersionCompareModal({ open, kind, baseVersion, versions = [], currentSnapshot, onClose, onRestore, restoring }) {
    // варианты сравнения: текущее состояние + версии, кроме A
    const options = useMemo(() => {
      const opts = [];
      if (currentSnapshot) opts.push({ value: 'current', label: 'Текущее состояние' });
      versions.forEach((vv) => { if (!baseVersion || vv.version_number !== baseVersion.version_number) opts.push({ value: String(vv.version_number), label: 'Версия ' + vv.version_number + ' · ' + fmt.dateShort(vv.created_at) }); });
      return opts;
    }, [versions, baseVersion, currentSnapshot]);

    const [target, setTarget] = useState(() => (options[0] ? options[0].value : 'current'));

    if (!baseVersion) return null;

    const targetSnap = target === 'current'
      ? currentSnapshot
      : (versions.find((vv) => String(vv.version_number) === String(target)) || {}).snapshot;
    const targetLabel = target === 'current' ? 'Текущее' : ('Версия ' + target);

    return (
      <Modal open={open} onClose={onClose} size="lg"
        title={'Сравнение · версия ' + baseVersion.version_number + ' → ' + targetLabel}
        footerLeft={<Button variant="secondary" iconLeft="refresh" loading={restoring} onClick={() => onRestore && onRestore(baseVersion.version_number)}>Восстановить версию {baseVersion.version_number}</Button>}
        footer={<Button variant="ghost" onClick={onClose}>Закрыть</Button>}>
        <div className="vcompare">
          <div className="vcompare__bar">
            <span className="t-caption text-dim">Сравнить версию <span className="num">{baseVersion.version_number}</span> с</span>
            <NativeSelect value={target} options={options} onChange={(e) => setTarget(e.target.value)} />
          </div>
          {!targetSnap ? (
            <div className="diff-identical"><Icon name="info" size={24} /><p className="t-body">Нечего сравнивать.</p></div>
          ) : (
            <DiffView kind={kind} a={baseVersion.snapshot} b={targetSnap}
              labelA={'Версия ' + baseVersion.version_number} labelB={targetLabel} />
          )}
        </div>
      </Modal>
    );
  }

export { VersionCompareModal };
